import './ipswitchclam/style';
import FormStructure from './ipswitchclam/form_structure';

export default FormStructure;